import React from "react";

import Header from "@/components/shared/Header";
import Table from "@/components/shared/Table";
import { roles as data } from "@constants/dummy";
import { roleColumns } from "@/constants/columns";
import { useNavigate } from "react-router-dom";
import { InputSwitch } from "primereact/inputswitch";
import TableMenu from "@/components/shared/TableMenu";
import { ConfirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import If from "@/components/shared/If";
import Container from "@/components/shared/Container";
import { useMountEffect } from "primereact/hooks";
import { filterByName } from "@/utils/filters";
import { useResetPagination } from "@/hooks/useResetPagination";

export default function Roles() {
  const navigate = useNavigate();

  const [roles, setRoles] = React.useState<any>([]);
  const [selectedRole, setSelectedRole] = React.useState<any>({});
  const [showDelete, setShowDelete] = React.useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [showSearch, toggleSearch] = React.useReducer((state) => !state, false);
  const [filter, setFilter] = React.useState<string>("");
  const resetPagination = useResetPagination(filter);
  const filteredRoles = filterByName(roles, filter, "name");

  const handleDelete = (id: any) => {
    // simulate delete
    setDeleteLoading(true);
    setTimeout(() => {
      setDeleteLoading(false);
      setShowDelete(false);
      toast.success("Role deleted successfully");
    }, 500);
  };

  useMountEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setRoles(data);
    }, 500);
  });

  return (
    <div>
      <Header
        title="Roles"
        onDownload={() => {}}
        extraAction="Create Role"
        extraActionIcon="pi pi-plus"
        onExtraAction={() => navigate("/admin/roles/new")}
        onSearch={toggleSearch}
        showSearch={showSearch}
        value={filter}
        onChange={(e: any) => setFilter(e.target.value)}
        onCloseSearch={() => {
          toggleSearch();
          setFilter("");
        }}
      />

      <Container loading={loading}>
        <Table
          data={filteredRoles}
          columns={[
            ...roleColumns(),
            {
              name: "Active",
              selector: (row: any) => row.active,
              cell: (row: any) => <InputSwitch checked={row.active} disabled />,
            },
            {
              selector: (row: any) => row.id,
              grow: 1,
              center: true,
              cell: (row: any) => (
                <If
                  condition={deleteLoading && row.id === selectedRole.id}
                  then={<i className="pi pi-spin pi-spinner" />}
                  else={
                    <TableMenu
                      menuType="editDelete"
                      onEdit={() => {
                        setSelectedRole(row);
                        navigate(`/admin/roles/${row.id}`, { state: row });
                      }}
                      onDelete={() => {
                        setSelectedRole(row);
                        setShowDelete(true);
                      }}
                    />
                  }
                />
              ),
            },
          ]}
          resetPagination={resetPagination}
          emptyIcon="pi-sitemap"
          emptyMessage="There are no roles to show at the moment"
        />

        <ConfirmDialog
          visible={showDelete}
          onHide={() => setShowDelete(false)}
          message="Are you sure you want to delete this role?"
          header="Delete Role"
          accept={() => {
            handleDelete(selectedRole.id);
          }}
          reject={() => setShowDelete(false)}
        />
      </Container>
    </div>
  );
}
